module.exports = __webpack_public_path__ + "svg/flags/Turks and Caicos Islands.svg";